import {
  getTransactionDateColumn,
  getAccountWithBankColumn,
  getAccountNumberColumn,
  getCounterpartyNameColumn,
  getCounterPartyAccountNumberColumn,
  getTransactionDescriptionColumn,
  getIncomeColumn,
  getExpenseColumn,
  getRateColumn,
  getBalanceColumn,
  getDeleteActionColumn,
} from "./statementColumnsHelpers"; // adjust path

export function createSearchStatementColumns({ currency, onDelete }) {
  return [
    getTransactionDateColumn(),
    getAccountWithBankColumn(),
    getAccountNumberColumn(),
    getCounterpartyNameColumn(),
    getCounterPartyAccountNumberColumn({ copyable: true }),
    getTransactionDescriptionColumn(),
    getIncomeColumn(currency),
    getExpenseColumn(currency),
    getRateColumn(),
    getBalanceColumn(currency, { strong: true }),
    getDeleteActionColumn(onDelete),
  ];
}